import { render, staticRenderFns } from "./OutputPicot.vue?vue&type=template&id=c461c8c6&scoped=true"
import script from "./OutputPicot.vue?vue&type=script&lang=js"
export * from "./OutputPicot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c461c8c6",
  null
  
)

export default component.exports